import * as React from 'react';
import * as styled from './styled';
import {ButtonProps, ButtonVariant} from './types';

/**
 * The button of filter.
 * @param {React.PropsWithChildren<ButtonProps>} props
 * @return {React.ReactElement<React.PropsWithChildren<ButtonProps>>}
 * @constructor
 */
function Button(
    props: React.PropsWithChildren<ButtonProps>,
): React.ReactElement<React.PropsWithChildren<ButtonProps>> {
  return (
    <styled.Wrapper {...props}>
      {props.children}
    </styled.Wrapper>
  );
}

Button.defaultProps = {
  variant: ButtonVariant.Default,
};

export default Button;
